<script setup lang="ts">
import { usarStoreFeatureFlags } from '@frontend/stores/feature-flags.store';

const props = defineProps<{
  name: string;
}>();
const featureFlags = usarStoreFeatureFlags();
featureFlags.cargar();
</script>

<template>
  <slot v-if="featureFlags.estaHabilitada(props.name)" name="funcionalidadHabilitada"></slot>
  <slot v-else name="funcionalidadDeshabilitada"></slot>
</template>
